import axios from "axios";
import { mapSizesToProducts } from "../../../src/utils/mapSizesToProduct";
import { useRouter } from "next/router";
import { NewProductCard } from "../../../src/components/newProductCard";
import { gql } from "graphql-tag";
import { parse } from "cookie";
import { categoryValues } from "../category.json";
import { getLocationDetail } from "../../../api.services.js/catalouge";
import UnbxdProductCard from "../../../src/UnbxdProductCard";
import ProductCard from "../../../src/productCard";
import client from "../../../graphqlClient";
import Category from "../../../src/components/category";
import { useEffect, useState } from "react";
import Head from "next/head";
import config from "../../../config";

export const getProductQueryServerSide = gql`
  query Products(
    $filter: ProductAttributeFilterInput!
    $sort: ProductAttributeSortInput!
    $pageSize: Int!
    $currentPage: Int!
  ) {
    products(
      filter: $filter
      sort: $sort
      pageSize: $pageSize
      currentPage: $currentPage
    ) {
      currentcategory {
        name
        description
        dynamic_content
        imageUrl
        meta_keywords
        meta_description
        meta_title
        schema
        breadcrumbs {
          category_id
          category_name
          category_level
          category_url_key
          category_url_path
        }
      }
      appliedFilters {
        label
        value
        attribute_code
      }
      aggregations(filter: { category: { includeDirectChildrenOnly: true } }) {
        attribute_code
        count
        label
        options {
          label
          value
          count
          swatch_data {
            type
            value
          }
        }
      }
      subcategories {
        id
        name
        imageUrl
      }
      total_count
      items {
        id
        name
        sku
        url_key
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
          maximum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
        }
        extraVariables {
          skd_stock
          dora_stock
          hoskote_stock
          west_zone_stock
          tile_type
          tile_area
          factory
          finish {
            label
            value
            url_key
          }
          tile_design
          is_enabled
          is_new
          image_url
          ambience_image_url
          product_url
          tile_size
          sq_ft_price
        }
      }
      sort_fields {
        default
        options {
          value
          label
        }
      }
    }
  }
`;

const unBxdUrl =
  "https://search.unbxd.io/efff4c80403c9e5356384bd354272ff4/ss-unbxd-aapac-dev-orientbell53741713874300/category?p-id=categoryPathId%3A%22%2Ftiles%2Fliving-room-tiles%22&facet.multiselect=true&spellcheck=true&pagetype=boolean&facet.multiselect=true&spellcheck=true&rows=28&version=V2&fallback=true&viewType=GRID&facet.version=V2&banner=true";

const livingTileSections = [
  {
    type: "Explore Living Room Floor Tiles",
    name: "floor",
    description:
      "Tiles give your living room a picture-perfect ambience, and when it comes to floor tiles, nothing can beat them. They are the first detail that catches the attention of anyone who steps into your home and have the power to redefine the room’s overall style. Whether your interior inspiration is modern or leaning towards a cozy, rustic vibe, the right floor tiles can enhance the overall aesthetic of your living room. From luxurious marble to beautiful wood-look tile, these flooring ideas for your living room are chic and easy-to-clean carpet alternatives. Choosing a suitable style, texture, and colour will make your living room cosy and trendy, so it remains a cherished haven for family and friends. So, take your time  browsing for different options to achieve the perfect match that speaks to your unique sense but provides the durability you need for everyday life.",
  },
  {
    type: "Explore Living Room Wall Tiles",
    name: "wall",
    description:
      "The walls of your living room are a blank canvas; turn yours into a masterpiece with wall tiles. The living room is a space where functionality and comfort come together, cohesively blending relaxation, entertainment, and everyday living.  With the right wall tiles, you can elevate the ambience, add character, and create a style statement that reflects your personality.From creating an accent wall that serves as a striking focal point to adding a dramatic effect through textures and patterns, the perfect wall tiles can completely transform your living room décor.You’re only limited by your imagination, and at Orientbell Tiles, each of our collections offers a rich palette of colours, textures, and styles to help you shape a living space that reflects your unique taste.",
  },
];

/**
 * @function getServerSideProps
 * @description This server-side function fetches data for the Living Room Tiles page.
 *              It handles both old and new components, and the logic is branched
 *              based on presence of query params.
 * @param {Object} context - The Next.js context object.
 * @returns {Object} An object containing the props to be passed to the page component.
 * @property {boolean} oldComponent - If true, render the old component.
 * @property {Object} oldComponentProps - Props to pass to the old component.
 * @property {boolean} fromPincode - If true, fetch data based on pincode cookie.
 * @property {string} categoryValue - The category value (e.g. "tiles/living-room-tiles").
 * @property {Object} response - The response from the Unbxd API.
 * @property {Object} sizeProductList - The size products list.
 * @property {string} error - The error message.
 */
export async function getServerSideProps(context) {
  const { query, resolvedUrl, req } = context;

  let props = {
    oldComponent: false,
    fromPincode: false,
    oldComponentProps: {},
    response: null,
    sizeProductList: null,
    error: null,
  };

  let cookies;
  let categoryValue = `tiles/living-room-tiles`;
  let value = "";
  let PinFromCityPage;
  let fitterrss = {};
  let fitterrss2 = {};
  let unBxdProd;
  let facetsUnbxd;
  let appliedFilterFromUnbxd;
  let data;

  // find the category ID & pin
  categoryValues.forEach((el) => {
    if (el.urlKey === categoryValue) {
      value = el.id;
      if (el.pin) PinFromCityPage = el.pin;
    }
  });

  // Base filter for both old & new
  fitterrss = { category_id: { in: [value] } };
  fitterrss2 = {};

  const errorArray = [
    "cat",
    "remc",
    "product_list_order",
    "product_list_dir",
    "mt",
    "trending",
    "tile_finish",
    "aor",
    "tiles_design",
    "tile_color",
    "p",
    "locations",
    ";popularity",
    "application",
    "type_finish",
    "plocation",
    ";trending",
    ";mt",
    "tiles_type",
    "finish",
    "limit",
    "available_region",
  ];

  // Old-component branch (any query params)
  if (Object.keys(query).length !== 0) {
    props.oldComponent = true;

    // parse cookies
    cookies = parse(req.headers.cookie || "");
    // build filters from query

    // if we have a pincode cookie
    if (cookies?.pincode) {
      props.fromPincode = true;
      const locationDetail = await getLocationDetail({
        pincode: cookies.pincode,
      });

      for (let f of Object.keys(context.query)) {
        if (f && context.query[f]) {
          if (
            !isNaN(context.query[f].split(",")[0]) &&
            !errorArray.includes(f)
          ) {
            fitterrss = {
              ...fitterrss,
              [f]: {
                in: context.query[f].split(",").map((cur) => Number(cur)),
              },
            };
            fitterrss2 = {
              ...fitterrss2,
              [f]: {
                $in: context.query[f].split(",").map((cur) => Number(cur)),
              },
            };
          }
        }
      }

      // {"tile_size":{"$in":[267]},"tile_category":{"$in":[222]},"tile_factory_production":{"$in":[201]}}
      // console.log(fitterrss2);

      const resp = await axios.post(
        `https://obl-js.orientbell.com/api/products?category=${value}&pincode=${cookies.pincode}`,
        fitterrss2
      );
      let ProdBySalesDate = resp.data || [];
      if (locationDetail?.data?.p_location) {
        fitterrss.plocation = { in: [locationDetail.data.p_location.value] };
      }

      props.oldComponentProps = {
        ...props.oldComponentProps,
        fromPincode: true,
        ProdBySalesDate,
        appliedFilters: fitterrss,
        value,
        displayLocationPopop: true,
        categoryValue,
        regionData: locationDetail?.data?.p_location || null,
        fitterrss,
        fitterrss2,
        UnbxdResponse: { numberOfProducts: 0, products: [] },
        facetsUnbxd: {},
        appliedFilterFromUnbxd: {},
      };
    } else {
      // no pincode -> Unbxd branch
      const queryParamsArray = Object.keys(query)
        .filter((k) => k !== "category")
        .map((k) => ({
          [k]: isNaN(query[k]) ? query[k] : Number(query[k]),
        }));

      // staging url
      // const baseUrl = `https://search.unbxd.io/efff4c80403c9e5356384bd354272ff4/ss-unbxd-aapac-dev-orientbell53741713874300/category`;

      // prod url
      const baseUrl = `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category`;

      const pId = `p-id=categoryPathId%3A%22${encodeURIComponent(
        resolvedUrl.split("?")[0]
      )}%22`;
      const extras = `&facet.multiselect=true&spellcheck=true&pagetype=boolean&rows=25&start=0&version=V2&fallback=true&viewType=GRID&facet.version=V2`;
      unBxdProd = await axios.get(`${baseUrl}?${pId}${extras}`);

      facetsUnbxd = unBxdProd.data.facets || null;
      appliedFilterFromUnbxd = queryParamsArray.length
        ? queryParamsArray
        : null;

      props.oldComponentProps = {
        ...props.oldComponentProps,
        fromPincode: false,
        UnbxdResponse: unBxdProd.data.response,
        appliedFilters: appliedFilterFromUnbxd,
        facetsUnbxd,
        displayLocationPopop: true,
        appliedFilterFromUnbxd,
      };
    }

    // handle 404 redirect if needed
    if (
      data?.products?.items?.length === 0 &&
      !data.products.currentcategory.description
    ) {
      return {
        redirect: { destination: "/404", permanent: false },
      };
    }

    props.oldComponentProps = {
      ...props.oldComponentProps,
      categoryValue,
    };
  }

  //  New-component branch (always runs)
  try {
    // run your existing GraphQL fetch for old component

    const [gqlRes, newProd] = await Promise.all([
      // magento query that fetches description and stuff
      client.query({
        query: getProductQueryServerSide,
        variables: {
          filter: fitterrss,
          sort: { recommended: "ASC" },
          pageSize: props.fromPincode ? 14 : 15,
          currentPage: 1,
        },
      }),
      // Unbxd query
      axios.get(unBxdUrl),
    ]);

    data = gqlRes.data;
    props.oldComponentProps.data = data;

    const raw = newProd.data.banner.banners[0].bannerHtml;
    const sizeProductList = mapSizesToProducts(
      raw,
      newProd.data.response.products
    );
    if (!newProd.data.response) throw new Error("No products found");

    props.response = newProd.data.response;
    props.sizeProductList = sizeProductList;
  } catch (err) {
    console.error(err);
    props.error = err.message;
  }

  return { props };
}

export default function Page({
  error,
  oldComponent = false,
  oldComponentProps,
  sizeProductList,
}) {
  const router = useRouter();

  const { data } = oldComponentProps;

  const [oldComponentState, setOldComponentState] = useState(oldComponent);

  // Function to relocate to new UI Component
  oldComponentProps = {
    ...oldComponentProps,
    removeAllFilterAndRedirect: () => setOldComponentState(false),
  };

  if (error) return <div>{error}</div>;
  if (oldComponentState) return <Category {...oldComponentProps} />;

  const breadsCrumbSchema = (cat) => {
    let arr = [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.orientbell.com",
      },
    ];

    for (let i = 0; i < cat.breadcrumbs.length; i++) {
      arr.push({
        "@type": "ListItem",
        position: i + 2,
        name: cat.breadcrumbs[i].category_name,
        item: `https://www.orientbell.com/${cat.breadcrumbs[i].category_url_path}`,
      });
    }

    return {
      __html: JSON.stringify({
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: arr,
      }),
    };
  };

  const webPageSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": "${router.asPath}",
        "headline": "",
        "breadcrumb": "Home > Tiles > ${
          data.products.currentcategory?.breadcrumbs
            ? data.products.currentcategory?.breadcrumbs[1]?.category_name
            : ""
        }",
        "name": "${data.products?.currentcategory?.meta_title}",
        "description": "${data.products?.currentcategory?.meta_description}"
      }`,
    };
  };

  // New UI rendering
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta name="title" content={data.products.currentcategory.meta_title} />
        <title>{data.products.currentcategory.meta_title}</title>
        <meta
          name="description"
          content={data.products.currentcategory.meta_description}
        />
        <meta
          name="keywords"
          content={data.products.currentcategory.meta_keywords}
        />
        {/* <meta name="robots" content="INDEX,FOLLOW"/> */}
        <meta name="format-detection" content="telephone=no" />
        <link
          rel="preconnect dns-prefetch"
          href="https://connect.facebook.net"
          crossorigin=""
        />
        <link
          rel="preconnect dns-prefetch"
          href="https://www.googletagmanager.com"
          crossorigin=""
        />
        <meta
          http-equiv="Accept-CH"
          content="viewport-width, width, device-memory, dpr, downlink, ect"
        />
        <meta name="pinterest-rich-pin" content="false" />
        <meta
          name="twitter:description"
          content={data.products.currentcategory.meta_description}
        />
        <meta
          name="twitter:title"
          content={data.products.currentcategory.meta_title}
        />
        <meta
          name="twitter:image"
          content={`${config.API_ENDPOINT}/media/img/logo.png`}
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="Orientbell" />
        <meta name="twitter:creator" content="Orientbell" />
        <meta
          property="og:url"
          content={`${config.HEADLESS_BASE_URL}/${
            router.query.category ? router.query.category.join("/") : "/tiles"
          }`}
        />
        <meta
          property="og:description"
          content={data.products.currentcategory.meta_description}
        />
        <meta
          property="og:title"
          content={data.products.currentcategory.meta_title}
        />
        {/* {data.products?.currentcategory?.schema && (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: data.products.currentcategory.schema
        .replace(/<script[^>]*>/g, '')
        .replace(/<\/script>/g, ''),
    }}
  />
)} */}

        {data.products?.currentcategory?.schema && (
          <>
            {data.products.currentcategory.schema
              .split(/<script[^>]*>/g) // Split by opening <script> tags
              .filter((schema) => schema.trim()) // Filter out any empty strings
              .map((schemaContent, index) => (
                <script
                  key={index} // Use index as the key
                  type="application/ld+json"
                  dangerouslySetInnerHTML={{
                    __html: schemaContent.replace(/<\/script>/g, ""), // Remove closing </script> tag
                  }}
                />
              ))}
          </>
        )}

        <meta
          property="og:image"
          content={`${config.API_ENDPOINT}/media/img/logo.png`}
        />
        <script
          type="text/javascript"
          src="https://cdn.roomvo.com/static/scripts/b2b/orientbell.js"
          defer=""
        ></script>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={webPageSchema()}
        />
        {/* {Object.keys(videoSchema).length > 0 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: videoSchema }}
          />
        )} */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={breadsCrumbSchema(
            data.products.currentcategory
          )}
        />
        {/* {pinFromCityPage && <script type="application/ld+json" />} */}
      </Head>

      <section className="category-bathroom-tile-section  new-cate-bath-tile-sect">
        <div className="container container-width">
          <div className="bread-crumb-row">
            <ul>
              <li>
                <a href={config.HEADLESS_BASE_URL}>Home</a>
              </li>
              <li>
                <a href="/tiles">Tiles</a>
              </li>
              {data.products.currentcategory.breadcrumbs &&
                data.products.currentcategory.breadcrumbs.map((bre, inddd) => {
                  if (inddd != 0 && bre.category_name != "All Tiles") {
                    return (
                      <li key={inddd}>
                        <a href={`/${bre.category_url_path}`}>
                          {bre.category_name}
                        </a>
                      </li>
                    );
                  }
                })}
            </ul>
          </div>

          <div className="categry-heading-row">
            <h1>Living Room Tiles</h1>

            {/* Description from magento */}
            {data.products?.currentcategory.description && (
              <div className="category_accordion_data ">
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.products.currentcategory.description.replace(
                      /<p>\s*<\/p>/g,
                      ""
                    ),
                  }}
                />
              </div>
            )}
          </div>

          {livingTileSections.map((section, index) => (
            <div className="categry-tile-prod-row" key={index}>
              {/* Wall or Floor */}
              <div className="exp-tile-text-row">
                <span>
                  {" "}
                  <h2>{section.type}</h2>
                  <a
                    href={
                      section.name === "wall"
                        ? "/tiles/living-room-tiles/living-room-wall-tiles"
                        : "/tiles/living-room-tiles/living-room-floor-tiles"
                    }
                  >
                    <button className="btn btn-primary">View All</button>
                  </a>
                </span>
                <p>{section.description}</p>
              </div>
              <ul className="categry-explore-wrap">
                {sizeProductList[section.name].map((obj, idx) => (
                  <li key={idx}>
                    <div className="categry-explore-size-head">
                      <h3>
                        <span>{obj.size}</span> Living Room{" "}
                        {/* Wall or Floor */}
                        {section.name.replace(/^./, (char) =>
                          char.toUpperCase()
                        )}{" "}
                        Tiles
                      </h3>
                    </div>
                    <div className="categry-explore-row">
                      {Array.isArray(obj.product) &&
                        obj.product.map((prod, productIndex) => (
                          <NewProductCard product={prod} key={productIndex} />
                        ))}
                    </div>
                    <div className="explore-pro-btn-row">
                      <a
                        href={`/tiles/living-room-tiles/${obj.size}${
                          obj.size !== "600x600"
                            ? "/" +
                              (section.name === "wall"
                                ? "walls-tiles"
                                : "floor-tiles")
                            : ""
                        }`}
                      >
                        <button className="btn btn-primary">View More</button>
                      </a>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div
            className="category_accordion_data"
            dangerouslySetInnerHTML={{
              __html: data.products?.currentcategory.dynamic_content.replace(
                /<p>\s*(&nbsp;)?\s*<\/p>/g,
                ""
              ),
            }}
          />
        </div>
      </section>
    </>
  );
}
